
import React from "react";
import {Link} from "react-router-dom";
import {getCookie} from "../utils/crypto";

interface Tab {
    name: string,
    path: string
}

const defaultTabs: Tab[] = [{
    name: "Recipes",
    path: "/cooking/recipe"
}, {
    name: "Ingredients",
    path: "/cooking/ingredient"
}, {
    name: "Tools",
    path: "/cooking/tool"
}, {
    name: "Notes",
    path: "/note"
}];

const NavigationTabs = ({tabs}: { tabs: Tab[] }) => {
    return (
        <nav className="navbar">
            <div className="tabs flex">
                {tabs.map((tab, index) => (
                    <div key={index}
                         className="tab font-bold hover:text-primary-32 focus:text-primary-32 px-4 cursor-pointer">
                        <Link to={tab.path}>{tab.name}</Link>
                    </div>
                ))}
            </div>

            <UserTab/>
        </nav>
    )
}

const UserTab = () => {
    if (getCookie("token")) {
        return (
            <div key="user"
                 className="tab font-bold hover:text-primary-32 focus:text-primary-32 px-4 cursor-pointer">
                <Link to="/user">User</Link>
            </div>
        );
    } else {
        return (
            <div key="sign-in"
                 className="tab font-bold hover:text-primary-32 focus:text-primary-32 px-4 cursor-pointer">
                <Link to="/user/sign-in">Sign In</Link>
            </div>
        );
    }
}

export {defaultTabs, NavigationTabs};